import React, { RefObject, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Icon, InputGroup } from "uikit";

import { SearchTextBox, SearchIconBorders } from "../../../..";
import { StyledRow } from "../../../../common";

const Group = styled(InputGroup.InputGroup)`
	width: 100%;
`;

const SearchBox: React.FC<SearchBox.Props> = ({
	inputRef,
	value,
	onChange,
	transactionText,
	onFocusChangeSearch,
}) => {
	const hoverWrapperRef = useRef<HTMLDivElement | null>(null);
	const { t } = useTranslation();

	const placeholder = useMemo(
		() =>
			t([
				transactionText?.query || "",
				"placeholder.base_query",
				"Enter text...",
			]) || "",
		[t, transactionText?.query],
	);

	try {
		return (
			<StyledRow
				w="100%"
				p="8px 24px"
				ref={hoverWrapperRef}
				onFocus={() => onFocusChangeSearch(true)}
				onBlur={() => onFocusChangeSearch(false)}
			>
				<Group sizes="32px auto">
					<SearchIconBorders>
						<Icon id="search" size={16} colors={["#5e6b73"]} />
					</SearchIconBorders>
					<SearchTextBox
						inputRef={inputRef}
						style={{ width: "100%" }}
						value={value}
						onChange={onChange}
						placeholder={placeholder}
					/>
				</Group>
			</StyledRow>
		);
	} catch {
		return null;
	}
};

declare namespace SearchBox {
	interface Props {
		inputRef: RefObject<HTMLInputElement>;

		value: string;
		onChange: (value: string) => void;
		transactionText?: {
			query?: string;
		};
		onFocusChangeSearch: (hovered: boolean) => void;
	}
}

export default SearchBox;
